<template>
  <div class="grid-view">
    <div class="main-content">
      <search-bar @change="searchChange" />
      <div class="section grid-wrapper">
        <intelligent-booking-table :row-data="rowData" tab-type="tabTrash" config-module="310203" />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="intelligent-tab-trash"
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="queryPageHandler"
        />
      </div>
    </div>
  </div>
</template>

<script>
import IntelligentBookingTable from '@/views/cargo/v0/SeaExport/IntelligentBooking/components/IntelligentBookingTable'
import { getLoading } from '@/utils/utilBaseElement'
import { queryIntelligentBookingList } from '@/api/seaExport/intelligentBooking'
import SearchBar from '@/views/cargo/v0/SeaExport/IntelligentBooking/components/SearchBar'
export default {
  name: 'TabTrash',
  components: { SearchBar, IntelligentBookingTable },
  data() {
    return {
      rowData: [],
      searchConditions: {
        total: 0,
        pageNum: 1,
        pageSize: 50,
        status: [4]
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.fetchData()
    },
    fetchData(params = this.searchConditions) {
      console.log('fetchFinished')
      this.loading = getLoading()
      queryIntelligentBookingList(params).then(res => {
        const { data } = res
        this.rowData = data.list
        this.searchConditions.total = Number(data.total)
        this.searchConditions.pageNum = data.pageNum
        this.searchConditions.pageSize = data.pageSize
      }).finally(() => {
        this.loading.close()
      })
    },
    queryPageHandler() {
      this.fetchData(this.searchConditions)
    },
    searchChange(e) {
      console.log(e)
      const params = this.searchConditions
      params.pageNum = 1
      switch (e.type) {
        case 'input':
          params.fileName = e.value
          break
        default:
          if (e.value) {
            params.days = e.value
          }
          params.fileName = ''
          break
      }
      this.fetchData(params)
    }
  }
}
</script>

<style scoped>

</style>
